// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.employee.detailed.request.AdminCreateEmployeeLoginDetailsRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminCreateEmployeeLoginDetailsRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Allow Emergency Access is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	emergencyAccess!: boolean;

	@GandalfValidator({ notNull: { message: 'Temporary Password is required' } })
	@GandalfValidator({ sizeString: { message: 'Temporary Password must be between 12 and 128 characters', minLength: 12, maxLength: 128 } })
	@GandalfProperty({ designType: String, isRequired: true })
	password!: string;

	@GandalfValidator({ notNull: { message: 'Username is required' } })
	@GandalfValidator({ sizeString: { message: 'Username must be between 5 and 100 characters', minLength: 5, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	username!: string;

}
